(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4234],{

/***/ 72419:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors",
      function () {
        return __webpack_require__(17233);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export imageLoader */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38579);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19142);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_environment__WEBPACK_IMPORTED_MODULE_3__);






var imageLoader = function(param) {
    var src = param.src;
    if (src.startsWith("http")) {
        return src;
    }
    return "".concat(_environment__WEBPACK_IMPORTED_MODULE_3__.environment.web_cdn_url, "web/assets/img/").concat(src);
};
var AnghamiImage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        unoptimized: true,
        loader: imageLoader
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AnghamiImage);


/***/ }),

/***/ 29303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Faq; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17668);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48439);
/* harmony import */ var _faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_faq_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93434);
/* harmony import */ var _helpers_styles_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88198);










var Faq = function(param) {
    var faqKey = param.faqKey, staticQuestions = param.staticQuestions, isShowHelpCenter = param.isShowHelpCenter, isDarkMode = param.isDarkMode, customStyles = param.customStyles, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, customIcon = param.customIcon;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), questions = ref1[0], setQuestions = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), questionsLoaded = ref2[0], setQuestionsLoaded = ref2[1];
    // use static questions if provided
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (staticQuestions && staticQuestions.length > 0) {
            setQuestions({
                results: staticQuestions
            });
            setQuestionsLoaded(true);
        }
    }, [
        staticQuestions
    ]);
    // fetch from API if faqKey is provided
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (!staticQuestions && faqKey) {
            // Move this to config file
            var url = "https://anghami.zendesk.com/api/v2/help_center/articles/search.json?locale=".concat(i18n.language, "&label_names=").concat(faqKey || "free");
            // free,LB,touch,alfa,nophone,web,web,usesmultipledevices) // body data type must match "Content-Type" header
            fetch(url).then(function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(response) {
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                        response.json().then(function(res) {
                            setQuestions(res);
                            setQuestionsLoaded(true);
                        });
                        return [
                            2
                        ];
                    });
                });
                return function(response) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function(_err) {
                console.log("--FAQ failed to load: ", _err);
            });
        }
    }, [
        faqKey,
        i18n.language,
        staticQuestions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.wrapper) || (isDarkMode ? (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dark_mode) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.content) || (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                children: questionsLoaded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["px-2-lg"]),
                    children: [
                        showTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.title) || "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().faqTitle), " black"),
                            children: t("FAQ")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .Accordion */ .UQ, {
                            allowZeroExpanded: true,
                            className: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.accordion) || (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().accordion),
                            children: questions.results.map(function(question, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItem */ .Qd, {
                                    className: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.accordionItem) || "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().accordion__item), " ").concat(index > 0 ? (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["border-line"]) : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItemHeading */ .Ol, {
                                            className: "noselect no-outline ".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["no-outline"])),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItemButton */ .on, {
                                                className: (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().accordion__button),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flexbox ".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().faqItemsFlex)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: customStyles === null || customStyles === void 0 ? void 0 : customStyles.question,
                                                            children: question.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItemState */ .CB, {
                                                                    children: function(param) {
                                                                        var expanded = param.expanded;
                                                                        return customIcon ? expanded ? customIcon.expanded : customIcon.collapsed : expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().plus), " ").concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().alt), " ").concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().expanded))
                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().plus), " ").concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().alt))
                                                                        });
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_accessible_accordion__WEBPACK_IMPORTED_MODULE_2__/* .AccordionItemPanel */ .Mt, {
                                            className: (0,_helpers_styles_helper__WEBPACK_IMPORTED_MODULE_8__/* .combineCN */ .O)((customStyles === null || customStyles === void 0 ? void 0 : customStyles.accordionPanel) || "", (_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default().accordion__panel)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: question.body
                                                },
                                                className: customStyles === null || customStyles === void 0 ? void 0 : customStyles.answer
                                            })
                                        })
                                    ]
                                }, question.id);
                            })
                        })
                    ]
                }) : null
            }),
            isShowHelpCenter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["help-center-wrapper"]), " flexbox colls centered"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["help-center-title"]), " bold"),
                        children: [
                            t("need_help"),
                            " ",
                            t("here_to_help")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "default-btn ".concat((_faq_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["default-btn"]), " purpleblue bold"),
                        onClick: function() {
                            return window.open("https://www.anghami.com/help", "_blank");
                        },
                        children: t("go_to_help_center")
                    })
                ]
            })
        ]
    });
};
Faq.propTypes = {
    faqKey: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    isShowHelpCenter: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (Faq);


/***/ }),

/***/ 96213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PageWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_dark_mode_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68366);







var Header = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(9800)]).then(__webpack_require__.bind(__webpack_require__, 59800))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59800)
            ];
        }
    }
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(8579), __webpack_require__.e(3878), __webpack_require__.e(5822)]).then(__webpack_require__.bind(__webpack_require__, 17909))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17909)
            ];
        }
    }
});
var PageWrapper = function(param) {
    var children = param.children, hideHeader = param.hideHeader, hideFooter = param.hideFooter, headerProps = param.headerProps, mainLayoutStyle = param.mainLayoutStyle, innerWebStyle = param.innerWebStyle;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var innerWebQP = Boolean(Number(router.query.innerweb));
    var darkModeQP = Boolean(Number(router.query.dark_mode));
    var isDarkModeEnabled = (0,_helpers_dark_mode_helper__WEBPACK_IMPORTED_MODULE_6__/* .shouldEnableDarkMode */ .N)(router.pathname, darkModeQP);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "page-wrapper ".concat(innerWebQP && "inner-web", " ").concat(isDarkModeEnabled ? "dark-mode" : ""),
        style: innerWebQP ? innerWebStyle : null,
        children: [
            hideHeader || innerWebQP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {
                headerProps: headerProps
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "main-layout ".concat(innerWebQP || (headerProps === null || headerProps === void 0 ? void 0 : headerProps.shouldStartTransparent) ? "" : "header-padding"),
                style: mainLayoutStyle,
                children: children
            }),
            hideFooter || innerWebQP ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 58622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PressCard */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _press_card_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23332);
/* harmony import */ var _press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var PressCard = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        href: data.link,
        target: "_blank",
        rel: "noreferrer",
        className: "".concat((_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().press_card), " ").concat((_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[data.direction]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().press_card_image_container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: data.image,
                    alt: data.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().press_card_date),
                children: data.date
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().press_card_title),
                children: data.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_press_card_module_scss__WEBPACK_IMPORTED_MODULE_2___default().press_card_excerpt),
                children: data.excerpt
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PressCard);


/***/ }),

/***/ 88198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ combineCN; }
/* harmony export */ });
var combineCN = function() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return (classNames === null || classNames === void 0 ? void 0 : classNames.filter(Boolean).join(" ")) || "";
};


/***/ }),

/***/ 17233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ investors; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(93434);
// EXTERNAL MODULE: ./components/investors/investor-header/investors-header.module.scss
var investors_header_module = __webpack_require__(43779);
var investors_header_module_default = /*#__PURE__*/__webpack_require__.n(investors_header_module);
// EXTERNAL MODULE: ./components/anghami-image/index.tsx
var anghami_image = __webpack_require__(42197);
// EXTERNAL MODULE: ./env/environment.js
var environment = __webpack_require__(19142);
;// CONCATENATED MODULE: ./components/investors/investor-header/index.tsx






function InvestorsHeader() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (investors_header_module_default()).header_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (investors_header_module_default()).image_container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (investors_header_module_default()).desktop_image_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(anghami_image/* default */.Z, {
                        priority: true,
                        src: environment.environment.new_web_cdn_url + "/new/investors/investors-desktop.png",
                        alt: "Investor Relations - Nasdaq",
                        width: 1920,
                        height: 740,
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (investors_header_module_default()).mobile_image_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(anghami_image/* default */.Z, {
                        priority: true,
                        src: environment.environment.new_web_cdn_url + "/new/investors/investors-mobile.png",
                        alt: "Investor Relations - Nasdaq",
                        width: 1920,
                        height: 740,
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (investors_header_module_default()).title_container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (investors_header_module_default()).main_title,
                        children: t("IR_landing_title")
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/pagewrapper/pagewrapper.tsx
var pagewrapper = __webpack_require__(96213);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/getPress.js
var getPress = __webpack_require__(98676);
// EXTERNAL MODULE: ./helpers/neogateway.ts
var neogateway = __webpack_require__(23750);
// EXTERNAL MODULE: ./components/press/press-card/press-card.tsx
var press_card = __webpack_require__(58622);
// EXTERNAL MODULE: ./components/press/press-container/press-container.module.scss
var press_container_module = __webpack_require__(51137);
var press_container_module_default = /*#__PURE__*/__webpack_require__.n(press_container_module);
// EXTERNAL MODULE: ./helpers/styles.helper.ts
var styles_helper = __webpack_require__(88198);
// EXTERNAL MODULE: ./pages/investors/investors.module.scss
var investors_module = __webpack_require__(25694);
var investors_module_default = /*#__PURE__*/__webpack_require__.n(investors_module);
;// CONCATENATED MODULE: ./components/press/press-container/index.tsx










function PressContainer(param) {
    var count = param.count, type = param.type;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), section = ref[0], setSection = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), moreData = ref2[0], setMoreData = ref2[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    react.useEffect(function() {
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getPress/* default */.Z, {
            page: "0",
            count: count,
            show_investor_articles: Boolean(type === "investor"),
            show_press_articles: Boolean(type === "press")
        }).then(function(param) {
            var res = param.data;
            var ref;
            if ((res === null || res === void 0 ? void 0 : (ref = res.sections) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                var ref1;
                var sectionData = res.sections[0].data;
                sectionData = Object.entries(sectionData).map(function(entry) {
                    return entry[1];
                });
                setSection(sectionData);
                setMoreData(Boolean((ref1 = res.sections[0]) === null || ref1 === void 0 ? void 0 : ref1.moreData));
                setPage(page + 1);
            }
        });
    }, []);
    var loadMore = function() {
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getPress/* default */.Z, {
            page: page.toString(),
            count: count
        }).then(function(param) {
            var res = param.data;
            var ref;
            if (((ref = res.sections) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                var ref1;
                var sectionData = res.sections[0].data;
                sectionData = Object.entries(sectionData).map(function(entry) {
                    return entry[1];
                });
                setSection(section.concat(sectionData));
                setMoreData(Boolean((ref1 = res.sections[0]) === null || ref1 === void 0 ? void 0 : ref1.moreData));
                setPage(page + 1);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "investors-news",
        className: (0,styles_helper/* combineCN */.O)((press_container_module_default()).main_wrapper, (investors_module_default()).main_section_wrapper, "d-flex f-column f-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("IR_landing_news")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (press_container_module_default()).press_card_container,
                children: section === null || section === void 0 ? void 0 : section.map(function(card) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(press_card/* default */.Z, {
                        data: card
                    }, card.id);
                })
            }),
            moreData && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (press_container_module_default()).load_more_btn,
                onClick: loadMore,
                children: t("show_more")
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(17486);
;// CONCATENATED MODULE: ./helpers/assets.helper.ts
var anghami_cdn = "https://cdnweb.anghami.com";
var getAssetPath = function(path) {
    return "".concat(anghami_cdn, "/new/").concat(path.startsWith("/") ? path.slice(1) : path);
};

;// CONCATENATED MODULE: ./metas/investors.config.js

/* harmony default export */ var investors_config = ({
    en: {
        openGraph: {
            url: "https://www.anghami.com/investors",
            title: "Investor Relations - Anghami",
            images: [
                {
                    url: getAssetPath("investors/metas/investors-meta-en.png"),
                    alt: "Investor Relations - Anghami"
                }
            ],
            site_name: "Anghami"
        },
        twitter: {
            handle: "@anghami",
            site: "@anghami",
            cardType: "summary_large_image"
        }
    },
    ar: {
        title: "علاقات المستثمرين - أنغامي",
        canonical: "https://www.anghami.com/investors",
        openGraph: {
            url: "https://www.anghami.com/investors",
            title: "علاقات المستثمرين - أنغامي",
            images: [
                {
                    url: getAssetPath("investors/metas/investors-meta-ar.png"),
                    alt: "علاقات المستثمرين - أنغامي"
                }
            ],
            site_name: "Anghami"
        },
        twitter: {
            handle: "@anghami",
            site: "@anghami",
            cardType: "summary_large_image"
        }
    },
    fr: {
        title: "Relations avec les investisseurs - Anghami",
        canonical: "https://www.anghami.com/investors",
        openGraph: {
            url: "https://www.anghami.com/investors",
            title: "Relations avec les investisseurs - Anghami",
            images: [
                {
                    url: getAssetPath("investors/metas/investors-meta-fr.png"),
                    alt: "Relations avec les investisseurs - Anghami"
                }
            ],
            site_name: "Anghami"
        },
        twitter: {
            handle: "@anghami",
            site: "@anghami",
            cardType: "summary_large_image"
        }
    }
});

// EXTERNAL MODULE: ./components/auth/index.tsx + 2 modules
var auth = __webpack_require__(92119);
// EXTERNAL MODULE: ./components/investors/about-section/about-section.module.scss
var about_section_module = __webpack_require__(80063);
var about_section_module_default = /*#__PURE__*/__webpack_require__.n(about_section_module);
;// CONCATENATED MODULE: ./components/investors/about-section/index.tsx






var InvestorsAboutSection = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,styles_helper/* combineCN */.O)((investors_module_default()).main_section_wrapper, (about_section_module_default()).about_section),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("about_anghami")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (about_section_module_default()).description,
                children: [
                    t("landing_about_whoweare_desc"),
                    "\xa0",
                    t("landing_about_whoweare_desc2")
                ]
            })
        ]
    });
};
/* harmony default export */ var about_section = (InvestorsAboutSection);

// EXTERNAL MODULE: ./components/investors/highlights-section/highlights.module.scss
var highlights_module = __webpack_require__(91313);
var highlights_module_default = /*#__PURE__*/__webpack_require__.n(highlights_module);
;// CONCATENATED MODULE: ./components/investors/highlights-section/index.tsx






var InvestorsHighlightsSection = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var highlights = [
        {
            number: t("investor_highlights_stat1_number"),
            label: t("investor_highlights_stat1_label")
        },
        {
            number: t("investor_highlights_stat2_number"),
            label: t("investor_highlights_stat2_label")
        },
        {
            number: t("investor_highlights_stat3_number"),
            label: t("investor_highlights_stat3_label")
        },
        {
            number: t("investor_highlights_stat4_number"),
            label: t("investor_highlights_stat4_label")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,styles_helper/* combineCN */.O)("d-flex f-column f-center", (highlights_module_default()).highlights_wrapper, (investors_module_default()).main_section_wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("investor_relations_key_highlights")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,styles_helper/* combineCN */.O)("d-flex f-column f-center w-100", (highlights_module_default()).content_wrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,styles_helper/* combineCN */.O)("d-flex f-center", (highlights_module_default()).stats_container),
                    children: highlights.map(function(highlight) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,styles_helper/* combineCN */.O)("d-flex f-column f-center", (highlights_module_default()).stat_item),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (highlights_module_default()).stat_number,
                                    children: highlight.number
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (highlights_module_default()).stat_label,
                                    children: highlight.label
                                })
                            ]
                        }, highlight.label);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var highlights_section = (InvestorsHighlightsSection);

// EXTERNAL MODULE: ./components/investors/investor-pdf-box/investor-pdf-box.module.scss
var investor_pdf_box_module = __webpack_require__(3607);
var investor_pdf_box_module_default = /*#__PURE__*/__webpack_require__.n(investor_pdf_box_module);
;// CONCATENATED MODULE: ./components/investors/investor-pdf-box/index.tsx




var PDFBox = function(param) {
    var title = param.title, data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (investor_pdf_box_module_default()).box,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investor_pdf_box_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (investor_pdf_box_module_default()).boxItemsContainer,
                children: data.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: item.url,
                        target: "_blank",
                        className: (investor_pdf_box_module_default()).boxItem,
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: environment.environment.images_cdn_url + "/investors/pdf.svg",
                                        alt: "pdf"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (investor_pdf_box_module_default()).arrow,
                                src: environment.environment.images_cdn_url + "/investors/arrow.svg",
                                alt: "arrow"
                            })
                        ]
                    }, item.title + item.url);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/investors/corporate-governance-section/corporate-governance-section.module.scss
var corporate_governance_section_module = __webpack_require__(41239);
var corporate_governance_section_module_default = /*#__PURE__*/__webpack_require__.n(corporate_governance_section_module);
;// CONCATENATED MODULE: ./components/investors/corporate-governance-section/index.tsx







function CorporateGovernanceSection(param) {
    var pdfLinks = param.pdfLinks;
    var t = (0,esm/* useTranslation */.$G)().t;
    var committeeCharters = pdfLinks === null || pdfLinks === void 0 ? void 0 : pdfLinks.filter(function(link) {
        return link.section === "Committee Charters";
    });
    var ethicsAndGuidelines = pdfLinks === null || pdfLinks === void 0 ? void 0 : pdfLinks.filter(function(link) {
        return link.section === "Code of Ethics and Guidelines";
    });
    var proxyStatementsLinks = pdfLinks === null || pdfLinks === void 0 ? void 0 : pdfLinks.filter(function(link) {
        return link.section === "Proxy Statement and Notice of Meeting";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "investors-governance",
        className: (0,styles_helper/* combineCN */.O)((corporate_governance_section_module_default()).main_wrapper, (investors_module_default()).main_section_wrapper, "d-flex f-column f-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("investor_relation_corporate_governance")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,styles_helper/* combineCN */.O)((corporate_governance_section_module_default()).content_wrapper, "d-flex f-justify-center"),
                children: [
                    (committeeCharters === null || committeeCharters === void 0 ? void 0 : committeeCharters.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFBox, {
                        title: t("IR_landing_committee_charters"),
                        data: committeeCharters
                    }),
                    (ethicsAndGuidelines === null || ethicsAndGuidelines === void 0 ? void 0 : ethicsAndGuidelines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFBox, {
                        title: t("IR_landing_code_of_ethics"),
                        data: ethicsAndGuidelines
                    }),
                    (proxyStatementsLinks === null || proxyStatementsLinks === void 0 ? void 0 : proxyStatementsLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFBox, {
                        title: t("IR_landing_proxy_statements"),
                        data: proxyStatementsLinks
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(23049);
// EXTERNAL MODULE: ../node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(78196);
// EXTERNAL MODULE: ../node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(54447);
// EXTERNAL MODULE: ../node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(85705);
// EXTERNAL MODULE: ../node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(58238);
// EXTERNAL MODULE: ../node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(12222);
// EXTERNAL MODULE: ../node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(70920);
// EXTERNAL MODULE: ./components/investors/investors-table/investors-table.module.scss
var investors_table_module = __webpack_require__(38681);
var investors_table_module_default = /*#__PURE__*/__webpack_require__.n(investors_table_module);
;// CONCATENATED MODULE: ./components/investors/investors-table/index.tsx
/* eslint-disable react/no-array-index-key */ 










function InvestorsTable(param) {
    var rows = param.rows;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        style: {
            background: "unset",
            boxShadow: "unset"
        },
        component: Paper/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            sx: {
                minWidth: 650
            },
            "aria-label": "rss table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "".concat((investors_table_module_default()).tableCell, " ").concat((investors_table_module_default()).headerCell),
                                children: t("IR_landing_date")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "".concat((investors_table_module_default()).tableCell, " ").concat((investors_table_module_default()).headerCell),
                                children: t("IR_landing_filing_type")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "".concat((investors_table_module_default()).tableCell, " ").concat((investors_table_module_default()).headerCell),
                                children: t("IR_landing_filing_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                className: "".concat((investors_table_module_default()).tableCell, " ").concat((investors_table_module_default()).headerCell)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: (rows === null || rows === void 0 ? void 0 : rows.length) > 0 ? rows.map(function(row, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            sx: {
                                "&:last-child td, &:last-child th": {
                                    border: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (investors_table_module_default()).tableCell,
                                    component: "th",
                                    scope: "row",
                                    children: row.filing_date
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (investors_table_module_default()).tableCell,
                                    children: row.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (investors_table_module_default()).tableCell,
                                    children: row.summary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    className: (investors_table_module_default()).tableCell,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (investors_table_module_default()).downloadIcon,
                                        href: row.link,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: t("IR_landing_download_view")
                                    })
                                })
                            ]
                        }, row.entry_id + "-" + index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                        className: "flexbox centered",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                            children: "Loading..."
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/investors/investor-sec-filings/investor-rss.module.scss
var investor_rss_module = __webpack_require__(682);
var investor_rss_module_default = /*#__PURE__*/__webpack_require__.n(investor_rss_module);
// EXTERNAL MODULE: ./helpers/helper.ts
var helper = __webpack_require__(19181);
;// CONCATENATED MODULE: ./components/investors/investor-sec-filings/index.tsx
/* eslint-disable react/no-array-index-key */ 







var COMMS_EMAIL = "comms@anghami.com";
var SEC_FILINGS_URL = "https://www.sec.gov/edgar/browse/index.html?cik=1871983";
function SecFilings(param) {
    var contents = param.contents;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,helper/* getSeperateText */.CY)(t("IR_landing_sec_disclaimer"), COMMS_EMAIL), firstPart = ref.firstPart, highlighted = ref.highlighted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "investors-filings",
        className: (0,styles_helper/* combineCN */.O)((investors_module_default()).main_section_wrapper, "d-flex f-column f-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("investor_relations_regulatory_filings")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (investor_rss_module_default()).content_wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (investor_rss_module_default()).subtitle,
                        children: t("IR_landing_sec")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (investor_rss_module_default()).disclaimer,
                        children: [
                            firstPart,
                            "\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:".concat(COMMS_EMAIL, "?subject=Investor%20relations"),
                                children: highlighted
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (investor_rss_module_default()).desktopView,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorsTable, {
                            rows: contents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (investor_rss_module_default()).mobileView,
                        children: contents === null || contents === void 0 ? void 0 : contents.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (investor_rss_module_default()).rssMobileBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: item.filing_date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: item.summary
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("IR_landing_download_view")
                                        })
                                    })
                                ]
                            }, item.entry_id + " " + index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (0,styles_helper/* combineCN */.O)((investor_rss_module_default()).show_more_btn, "d-flex f-center"),
                onClick: function() {
                    window.open(SEC_FILINGS_URL, "_blank");
                },
                children: t("show_more")
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/investors/resources-section/resources.module.scss
var resources_module = __webpack_require__(29830);
var resources_module_default = /*#__PURE__*/__webpack_require__.n(resources_module);
;// CONCATENATED MODULE: ./components/investors/resources-section/index.tsx







var IR_EMAIL = "anghami@apcoworldwide.com";
var InvestorsResourcesSection = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "investors-resources",
        className: (investors_module_default()).main_section_wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("investor_relations_investor_resources")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,styles_helper/* combineCN */.O)((resources_module_default()).content_wrapper, "d-flex f-justify-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "mailto:".concat(IR_EMAIL, "?subject=Investor%20relations"),
                        className: (0,styles_helper/* combineCN */.O)((resources_module_default()).resource_item, "d-flex f-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(environment.environment.new_web_cdn_url, "/new/investors/email.svg"),
                                alt: "Contact IR",
                                className: (resources_module_default()).icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (resources_module_default()).label,
                                children: t("investor_relations_contact_ir")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,styles_helper/* combineCN */.O)((resources_module_default()).resource_item, (resources_module_default()).disabled, "d-flex f-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (resources_module_default()).badge,
                                children: t("coming_soon_badge")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "".concat(environment.environment.new_web_cdn_url, "/new/investors/corporate-presentation.svg"),
                                alt: "Corporate Presentation",
                                className: (resources_module_default()).icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (resources_module_default()).label,
                                children: t("investor_relations_corporate_presentation")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var resources_section = (InvestorsResourcesSection);

// EXTERNAL MODULE: ./components/investors/investors-faq-section/investors-faq.module.scss
var investors_faq_module = __webpack_require__(94339);
var investors_faq_module_default = /*#__PURE__*/__webpack_require__.n(investors_faq_module);
// EXTERNAL MODULE: ./components/faq/index.tsx
var faq = __webpack_require__(29303);
;// CONCATENATED MODULE: ./components/investors/investors-faq-section/index.tsx








var InvestorsFAQSection = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var customIcons = {
        collapsed: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: environment.environment.images_cdn_url + "/investors/arrow.svg",
            alt: "expand",
            className: (investors_faq_module_default()).arrowIcon
        }),
        expanded: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: environment.environment.images_cdn_url + "/investors/arrow.svg",
            alt: "collapse",
            className: "".concat((investors_faq_module_default()).arrowIcon, " ").concat((investors_faq_module_default()).arrowExpanded)
        })
    };
    // build static FAQ questions from translations
    var faqQuestions = react.useMemo(function() {
        var questions = [];
        var index = 1;
        while(t("ir_faq_q".concat(index), {
            defaultValue: ""
        })){
            var question = t("ir_faq_q".concat(index));
            var answer = t("ir_faq_a".concat(index));
            if (question && answer) {
                questions.push({
                    id: "investor_faq_".concat(index),
                    title: question,
                    body: answer
                });
            }
            index++;
        }
        return questions;
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,styles_helper/* combineCN */.O)((investors_module_default()).main_section_wrapper, (investors_faq_module_default()).faq_wrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (investors_module_default()).title,
                children: t("investor_relations_frequently_asked_questions")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq/* Faq */.B, {
                staticQuestions: faqQuestions,
                showTitle: false,
                customIcon: customIcons,
                customStyles: {
                    content: (investors_faq_module_default()).faqContent,
                    question: (investors_faq_module_default()).faqQuestion,
                    accordionPanel: (investors_faq_module_default()).accordionPanel,
                    answer: (investors_faq_module_default()).faqAnswer
                }
            })
        ]
    });
};
/* harmony default export */ var investors_faq_section = (InvestorsFAQSection);

// EXTERNAL MODULE: ./components/investors/nav-tabs/nav-tabs.module.scss
var nav_tabs_module = __webpack_require__(12145);
var nav_tabs_module_default = /*#__PURE__*/__webpack_require__.n(nav_tabs_module);
;// CONCATENATED MODULE: ./components/investors/nav-tabs/index.tsx






var InvestorsNavTabs = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var tabs = [
        {
            id: "news",
            labelKey: "IR_landing_news",
            targetId: "investors-news",
            icon: "".concat(environment.environment.new_web_cdn_url, "/new/investors/news.svg")
        },
        {
            id: "governance",
            labelKey: "investor_relation_corporate_governance",
            targetId: "investors-governance",
            icon: "".concat(environment.environment.new_web_cdn_url, "/new/investors/corporate-gov.svg")
        },
        {
            id: "filings",
            labelKey: "investor_relations_regulatory_filings",
            targetId: "investors-filings",
            icon: "".concat(environment.environment.new_web_cdn_url, "/new/investors/filings.svg")
        },
        {
            id: "resources",
            labelKey: "investor_relations_investor_resources",
            targetId: "investors-resources",
            icon: "".concat(environment.environment.new_web_cdn_url, "/new/investors/resources.svg")
        }
    ];
    var scrollToSection = function(targetId) {
        var element = document.getElementById(targetId);
        if (element) {
            var yOffset = -100;
            var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (0,styles_helper/* combineCN */.O)("d-flex f-column f-center w-100", (nav_tabs_module_default()).nav_wrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,styles_helper/* combineCN */.O)("d-flex f-justify-center", (nav_tabs_module_default()).nav_container),
            children: tabs.map(function(tab) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: (0,styles_helper/* combineCN */.O)("d-flex f-center", (nav_tabs_module_default()).nav_tab),
                    onClick: function() {
                        scrollToSection(tab.targetId);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: tab.icon,
                            alt: tab.id,
                            className: (nav_tabs_module_default()).tab_icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t(tab.labelKey)
                        })
                    ]
                }, tab.id);
            })
        })
    });
};
/* harmony default export */ var nav_tabs = (InvestorsNavTabs);

;// CONCATENATED MODULE: ./pages/investors/index.tsx


















function InvestorsPage(param) {
    var lang = param.lang, contents = param.contents;
    var language = esm/* i18n.language */.ag.language || lang || "en";
    var pdf_links = contents.pdf_links, sec_filings = contents.sec_filings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pagewrapper/* PageWrapper */.F, {
        headerProps: {
            shouldStartTransparent: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdnweb.anghami.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: "https://cdnweb.anghami.com/tv/AdapterArabicDisplayWeb-Rg.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: "https://cdnweb.anghami.com/tv/AdapterArabicDisplayWeb-Bd.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        href: "https://cdnweb.anghami.com/new/fonts/anton/Anton-Regular.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, investors_config[language])),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InvestorsHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_tabs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(highlights_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PressContainer, {
                count: 6,
                type: "investor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateGovernanceSection, {
                pdfLinks: pdf_links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecFilings, {
                contents: sec_filings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(investors_faq_section, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(resources_section, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var investors = ((0,auth/* default */.Z)(InvestorsPage));


/***/ }),

/***/ 48439:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"faq_d-flex__5_T0J","f-column":"faq_f-column__C6umg","f-justify-center":"faq_f-justify-center__ClxxG","f-justify-between":"faq_f-justify-between__mjNO9","f-justify-start":"faq_f-justify-start__z9mHf","f-justify-end":"faq_f-justify-end__5uZkq","f-align-center":"faq_f-align-center__i2pHh","f-align-start":"faq_f-align-start__75xhU","f-align-stretch":"faq_f-align-stretch__8EaoX","f-align-end":"faq_f-align-end__BxMH2","f-center":"faq_f-center__BMsVH","position-relative":"faq_position-relative__oBin7","w-100":"faq_w-100__m9lsd","content":"faq_content__Ymp8G","accordion":"faq_accordion__rTTws","accordion__button":"faq_accordion__button___NeEU","accordion__panel":"faq_accordion__panel__au3rp","fadein":"faq_fadein__SHNTH","faqItemsFlex":"faq_faqItemsFlex__umsFB","border-line":"faq_border-line__OcG10","faqTitle":"faq_faqTitle__f58G_","no-outline":"faq_no-outline__y1VDV","fap-arrows":"faq_fap-arrows__vNHbG","reversed":"faq_reversed__bqsST","help-center-wrapper":"faq_help-center-wrapper__QjHOs","help-center-title":"faq_help-center-title__lyivn","default-btn":"faq_default-btn__MRwnq","accordion__item":"faq_accordion__item__kqSlc","plus":"faq_plus__g5cN0","alt":"faq_alt__gZo0G","expanded":"faq_expanded__hcQmL","px-2-lg":"faq_px-2-lg__ov60v","dark_mode":"faq_dark_mode__4oCRp"};

/***/ }),

/***/ 80063:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"about-section_d-flex__wHxux","f-column":"about-section_f-column__dJBMd","f-justify-center":"about-section_f-justify-center__iiycY","f-justify-between":"about-section_f-justify-between__qHpVp","f-justify-start":"about-section_f-justify-start__pzYx9","f-justify-end":"about-section_f-justify-end__lrnOt","f-align-center":"about-section_f-align-center__VTZZf","f-align-start":"about-section_f-align-start__Os_lf","f-align-stretch":"about-section_f-align-stretch__NPdjp","f-align-end":"about-section_f-align-end__I0tql","f-center":"about-section_f-center__vQDOS","position-relative":"about-section_position-relative__IGZee","w-100":"about-section_w-100__903lG","about_section":"about-section_about_section__pJl_c","description":"about-section_description__5Z12R"};

/***/ }),

/***/ 41239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"corporate-governance-section_d-flex__cEaQL","f-column":"corporate-governance-section_f-column__ekSmJ","f-justify-center":"corporate-governance-section_f-justify-center__DY_Ny","f-justify-between":"corporate-governance-section_f-justify-between__d_LAm","f-justify-start":"corporate-governance-section_f-justify-start__ZKWiC","f-justify-end":"corporate-governance-section_f-justify-end__lTubg","f-align-center":"corporate-governance-section_f-align-center__K1Zok","f-align-start":"corporate-governance-section_f-align-start__fNpx4","f-align-stretch":"corporate-governance-section_f-align-stretch__i27Kk","f-align-end":"corporate-governance-section_f-align-end__7bbrI","f-center":"corporate-governance-section_f-center__S_FcL","position-relative":"corporate-governance-section_position-relative__6TQOC","w-100":"corporate-governance-section_w-100__zuBxH","main_wrapper":"corporate-governance-section_main_wrapper__gAwjG","content_wrapper":"corporate-governance-section_content_wrapper__pPrWv"};

/***/ }),

/***/ 91313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"highlights_d-flex__LYzAL","f-column":"highlights_f-column__H9b9I","f-justify-center":"highlights_f-justify-center__ElSCy","f-justify-between":"highlights_f-justify-between__OW3bS","f-justify-start":"highlights_f-justify-start__kA_5G","f-justify-end":"highlights_f-justify-end__Xj7EB","f-align-center":"highlights_f-align-center__jnVA2","f-align-start":"highlights_f-align-start__qvVJj","f-align-stretch":"highlights_f-align-stretch__FVcMu","f-align-end":"highlights_f-align-end__es12P","f-center":"highlights_f-center__6xF0W","position-relative":"highlights_position-relative__FKmuX","w-100":"highlights_w-100__Wjsiv","highlights_wrapper":"highlights_highlights_wrapper__aSbLO","stats_container":"highlights_stats_container__2j8BK","stat_item":"highlights_stat_item__LUcg0","stat_number":"highlights_stat_number__RA1XS","stat_label":"highlights_stat_label__C3ldQ","title":"highlights_title__nbw5Z","content_wrapper":"highlights_content_wrapper__5Sw_Q"};

/***/ }),

/***/ 43779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investors-header_d-flex__S7puh","f-column":"investors-header_f-column__jbgSS","f-justify-center":"investors-header_f-justify-center__5XIZt","f-justify-between":"investors-header_f-justify-between__kHx9K","f-justify-start":"investors-header_f-justify-start__pjQH8","f-justify-end":"investors-header_f-justify-end__7DqzP","f-align-center":"investors-header_f-align-center___DIiM","f-align-start":"investors-header_f-align-start__iFg5T","f-align-stretch":"investors-header_f-align-stretch__CnKJc","f-align-end":"investors-header_f-align-end__5Levt","f-center":"investors-header_f-center__6CBZ1","position-relative":"investors-header_position-relative__eE0Lj","w-100":"investors-header_w-100__wFLrT","header_wrapper":"investors-header_header_wrapper__K_bmr","title_container":"investors-header_title_container__jzBph","main_title":"investors-header_main_title__ReGot","image_container":"investors-header_image_container__b2PYM","desktop_image_wrapper":"investors-header_desktop_image_wrapper__MVfwb","mobile_image_wrapper":"investors-header_mobile_image_wrapper__BX18x"};

/***/ }),

/***/ 3607:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investor-pdf-box_d-flex__E6nES","f-column":"investor-pdf-box_f-column__aBvkH","f-justify-center":"investor-pdf-box_f-justify-center___0Vka","f-justify-between":"investor-pdf-box_f-justify-between__MDJk0","f-justify-start":"investor-pdf-box_f-justify-start__HRWnK","f-justify-end":"investor-pdf-box_f-justify-end__Hoyj5","f-align-center":"investor-pdf-box_f-align-center__C5NFJ","f-align-start":"investor-pdf-box_f-align-start__UShcg","f-align-stretch":"investor-pdf-box_f-align-stretch___AOyS","f-align-end":"investor-pdf-box_f-align-end__kXwSW","f-center":"investor-pdf-box_f-center__ldx8y","position-relative":"investor-pdf-box_position-relative__TbYl6","w-100":"investor-pdf-box_w-100__7Rbym","box":"investor-pdf-box_box__ejT_l","title":"investor-pdf-box_title__oHrtW","boxItemsContainer":"investor-pdf-box_boxItemsContainer__4PExd","boxItem":"investor-pdf-box_boxItem__h7pH3","arrow":"investor-pdf-box_arrow__GFeoz"};

/***/ }),

/***/ 682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investor-rss_d-flex__JK_nD","f-column":"investor-rss_f-column__fqpBg","f-justify-center":"investor-rss_f-justify-center__VJRgm","f-justify-between":"investor-rss_f-justify-between__VpcoA","f-justify-start":"investor-rss_f-justify-start__lxtsO","f-justify-end":"investor-rss_f-justify-end__ekfKp","f-align-center":"investor-rss_f-align-center__AgSuj","f-align-start":"investor-rss_f-align-start__gjkoc","f-align-stretch":"investor-rss_f-align-stretch__IZu2A","f-align-end":"investor-rss_f-align-end__N7vyk","f-center":"investor-rss_f-center__jeYFb","position-relative":"investor-rss_position-relative__Jb9AY","w-100":"investor-rss_w-100__WFij5","mobileView":"investor-rss_mobileView__GKT23","desktopView":"investor-rss_desktopView__FQg2U","content_wrapper":"investor-rss_content_wrapper__7fGwz","subtitle":"investor-rss_subtitle__ZxDMM","disclaimer":"investor-rss_disclaimer__NzST7","rssMobileBox":"investor-rss_rssMobileBox__jTugQ","show_more_btn":"investor-rss_show_more_btn___aPFh"};

/***/ }),

/***/ 94339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investors-faq_d-flex__bKq_U","f-column":"investors-faq_f-column__WaZE5","f-justify-center":"investors-faq_f-justify-center__JDI80","f-justify-between":"investors-faq_f-justify-between__dBOf0","f-justify-start":"investors-faq_f-justify-start__7sSlF","f-justify-end":"investors-faq_f-justify-end__DM_Xr","f-align-center":"investors-faq_f-align-center___oGy4","f-align-start":"investors-faq_f-align-start__rzWQy","f-align-stretch":"investors-faq_f-align-stretch__8S_xU","f-align-end":"investors-faq_f-align-end__2fh0n","f-center":"investors-faq_f-center__KbHNq","position-relative":"investors-faq_position-relative__t8k0h","w-100":"investors-faq_w-100__hhkD4","faq_wrapper":"investors-faq_faq_wrapper__o1wuT","faqContent":"investors-faq_faqContent__cKCCs","faqQuestion":"investors-faq_faqQuestion__NCq9e","accordionPanel":"investors-faq_accordionPanel__zIZzV","slideDownFade":"investors-faq_slideDownFade__Ua8nn","faqAnswer":"investors-faq_faqAnswer__cbJv5","fadeIn":"investors-faq_fadeIn__Njc3f","arrowIcon":"investors-faq_arrowIcon__46cyZ","arrowExpanded":"investors-faq_arrowExpanded__RfH32"};

/***/ }),

/***/ 38681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investors-table_d-flex__GJyI9","f-column":"investors-table_f-column__7ZYOE","f-justify-center":"investors-table_f-justify-center__bdLIb","f-justify-between":"investors-table_f-justify-between__lk78_","f-justify-start":"investors-table_f-justify-start__wmfr4","f-justify-end":"investors-table_f-justify-end__ZwIMj","f-align-center":"investors-table_f-align-center__2zmo_","f-align-start":"investors-table_f-align-start__YACO6","f-align-stretch":"investors-table_f-align-stretch__ehApW","f-align-end":"investors-table_f-align-end__Old9W","f-center":"investors-table_f-center__QHfbF","position-relative":"investors-table_position-relative__jz68D","w-100":"investors-table_w-100__AkHyS","downloadIcon":"investors-table_downloadIcon__xoE9j","tableCell":"investors-table_tableCell__8UaWz","headerCell":"investors-table_headerCell__o9fBB"};

/***/ }),

/***/ 12145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"nav-tabs_d-flex__8KwNr","f-column":"nav-tabs_f-column__fZXeB","f-justify-center":"nav-tabs_f-justify-center__q3MB8","f-justify-between":"nav-tabs_f-justify-between__mR_q5","f-justify-start":"nav-tabs_f-justify-start__OOwCF","f-justify-end":"nav-tabs_f-justify-end__K_hQ6","f-align-center":"nav-tabs_f-align-center__lFuGz","f-align-start":"nav-tabs_f-align-start__y0prH","f-align-stretch":"nav-tabs_f-align-stretch__vh8uL","f-align-end":"nav-tabs_f-align-end__cq5yA","f-center":"nav-tabs_f-center__K0uTU","position-relative":"nav-tabs_position-relative__rt0g4","w-100":"nav-tabs_w-100__5xQIc","nav_wrapper":"nav-tabs_nav_wrapper__nXPy3","nav_container":"nav-tabs_nav_container__S6_BG","nav_tab":"nav-tabs_nav_tab__TkPnG","tab_icon":"nav-tabs_tab_icon__VGBl3"};

/***/ }),

/***/ 29830:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"resources_d-flex__WOYuU","f-column":"resources_f-column__rQ9LP","f-justify-center":"resources_f-justify-center__4IHBB","f-justify-between":"resources_f-justify-between__LPGfE","f-justify-start":"resources_f-justify-start__cWROn","f-justify-end":"resources_f-justify-end__Mn5Ij","f-align-center":"resources_f-align-center__fR8bk","f-align-start":"resources_f-align-start__X1B_b","f-align-stretch":"resources_f-align-stretch__Qekix","f-align-end":"resources_f-align-end__OoeZM","f-center":"resources_f-center__XY8EF","position-relative":"resources_position-relative___ejKj","w-100":"resources_w-100___Z5ag","content_wrapper":"resources_content_wrapper__JUY5U","resource_item":"resources_resource_item__C_du2","disabled":"resources_disabled__b62C2","icon":"resources_icon__oHcil","badge":"resources_badge__4ny06","label":"resources_label__A0wSR"};

/***/ }),

/***/ 23332:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"press-card_d-flex__2Lk8Z","f-column":"press-card_f-column__JTJfQ","f-justify-center":"press-card_f-justify-center__7F6qN","f-justify-between":"press-card_f-justify-between__kN1hw","f-justify-start":"press-card_f-justify-start__UNuwL","f-justify-end":"press-card_f-justify-end__grT3T","f-align-center":"press-card_f-align-center___97zc","f-align-start":"press-card_f-align-start__0ePvn","f-align-stretch":"press-card_f-align-stretch__aqbI7","f-align-end":"press-card_f-align-end__UKK8O","f-center":"press-card_f-center__lgKMO","position-relative":"press-card_position-relative__RrftG","w-100":"press-card_w-100__l53UG","press_card":"press-card_press_card__VNVMj","press_card_image_container":"press-card_press_card_image_container__U1tt6","press_card_date":"press-card_press_card_date__boCCf","press_card_title":"press-card_press_card_title__HTKn2","press_card_excerpt":"press-card_press_card_excerpt__yFjcu","ltr":"press-card_ltr__L9ynE","rtl":"press-card_rtl__5kB4x"};

/***/ }),

/***/ 51137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"press-container_d-flex__W1eN2","f-column":"press-container_f-column__srrqk","f-justify-center":"press-container_f-justify-center__XnoJd","f-justify-between":"press-container_f-justify-between__OJjcc","f-justify-start":"press-container_f-justify-start__ZBNqS","f-justify-end":"press-container_f-justify-end__ZHkYb","f-align-center":"press-container_f-align-center__0t9IP","f-align-start":"press-container_f-align-start__IfyrH","f-align-stretch":"press-container_f-align-stretch__2r7Eb","f-align-end":"press-container_f-align-end__DldzO","f-center":"press-container_f-center__xhdvl","position-relative":"press-container_position-relative__C21sZ","w-100":"press-container_w-100__4reaH","main_wrapper":"press-container_main_wrapper__T0s5W","press_card_container":"press-container_press_card_container__a_J0w","load_more_btn":"press-container_load_more_btn___JZ_t"};

/***/ }),

/***/ 25694:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"investors_d-flex__l__WM","f-column":"investors_f-column__k8ze3","f-justify-center":"investors_f-justify-center__vXQla","f-justify-between":"investors_f-justify-between__ygbW5","f-justify-start":"investors_f-justify-start__X6hfJ","f-justify-end":"investors_f-justify-end__DETaL","f-align-center":"investors_f-align-center__bkqtz","f-align-start":"investors_f-align-start__UFup0","f-align-stretch":"investors_f-align-stretch__a4Leg","f-align-end":"investors_f-align-end__Xh763","f-center":"investors_f-center__OCquR","position-relative":"investors_position-relative__JL5Mo","w-100":"investors_w-100__U3Gqq","title":"investors_title__Jg1hM","main_section_wrapper":"investors_main_section_wrapper__5Tdaq"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7953,5490,8579,4282,7324,2119,9774,2888,179], function() { return __webpack_exec__(72419); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);